/** Query `source` when opening standard detail from machinery directive Standards step */
export const STANDARD_DETAIL_SOURCE_MACHINERY_DIRECTIVE_STANDARDS =
  'machinery-directive-standards' as const

const QUERY_SOURCE = 'source'
const QUERY_PRODUCT_ID = 'productId'
const QUERY_COMPLIANCE_ID = 'complianceId'

export function buildProductMachineryDirectiveStandardsDetailSearch(
  productId: string,
  machineryDirectiveComplianceId: string
): string {
  const params = new URLSearchParams({
    [QUERY_SOURCE]: STANDARD_DETAIL_SOURCE_MACHINERY_DIRECTIVE_STANDARDS,
    [QUERY_PRODUCT_ID]: productId,
    [QUERY_COMPLIANCE_ID]: machineryDirectiveComplianceId,
  })
  return `?${params.toString()}`
}

export type StandardDetailBackSource =
  | 'standards-library'
  | 'machinery-directive-standards'

/** Whether the user opened this page from machinery directive Standards (full query) */
export function getStandardDetailBackSource(
  searchParams: URLSearchParams
): StandardDetailBackSource {
  const source = searchParams.get(QUERY_SOURCE)
  const productId = searchParams.get(QUERY_PRODUCT_ID)
  const complianceId = searchParams.get(QUERY_COMPLIANCE_ID)
  if (
    source === STANDARD_DETAIL_SOURCE_MACHINERY_DIRECTIVE_STANDARDS &&
    productId &&
    complianceId
  ) {
    return 'machinery-directive-standards'
  }
  return 'standards-library'
}

/** Resolves the Back button destination from standard detail URL search params */
export function resolveStandardDetailBackTo(
  searchParams: URLSearchParams
): string {
  if (
    getStandardDetailBackSource(searchParams) !==
    'machinery-directive-standards'
  ) {
    return '/standards-library'
  }
  const productId = searchParams.get(QUERY_PRODUCT_ID)
  const complianceId = searchParams.get(QUERY_COMPLIANCE_ID)
  if (!complianceId || !productId) {
    return '/standards-library'
  }
  return `/product-catalog/${productId}/machinery-directive/${complianceId}/standards`
}
